import { mapToNamedProperty, NamedProperty } from "sprint-common-web";

import { SystemPlatformResponseItem } from "../../../common/api/orders-api/airline/GetSystemPlatformsListResponse";

export interface SystemPlatformListingItem {
    systemId: string;
    systemName: string;
    integrator: NamedProperty;
    isModified?: boolean;
}

export const mapToSystemPlatformListingItem = (response: SystemPlatformResponseItem): SystemPlatformListingItem => {
    return {
        systemId: response.system.id,
        systemName: response.system.name,
        integrator: mapToNamedProperty(response.integrator)
    };
};
